import { Controller } from "@hotwired/stimulus";

// Bulk-approve toolbar on the brand Payments list. The row checkboxes live in
// the table but are wired to the toolbar's form via HTML5 `form="bulkApproveForm"`,
// so no JS is needed for submission — this only enables the button and shows a
// live count once something is selected. Server re-checks each row's authority
// and state, so a stray submit is safe.
export default class extends Controller {
  static targets = ["checkbox", "submit", "count"];

  connect() {
    this.toggle();
  }

  toggle() {
    const n = this.checkboxTargets.filter((cb) => cb.checked).length;
    if (this.hasSubmitTarget) this.submitTarget.disabled = n === 0;
    if (this.hasCountTarget)
      this.countTarget.textContent = n > 0 ? ` (${n})` : "";
  }
}
